import { render, staticRenderFns } from "./account-edit.vue?vue&type=template&id=52ae505e&"
import script from "./account-edit.vue?vue&type=script&lang=js&"
export * from "./account-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports